import { motion } from "framer-motion";

const pressLogos = [
  { name: "Product Hunt", icon: "🚀" },
  { name: "Maddyness", icon: "📰" },
  { name: "FrenchWeb", icon: "🇫🇷" },
  { name: "Les Échos Start", icon: "📊" },
  { name: "BPI France", icon: "🏦" },
];

const SellPressSection = () => (
  <section className="py-12 border-y border-border/20">
    <div className="container mx-auto px-6">
      <motion.p
        className="text-center text-xs text-muted-foreground uppercase tracking-widest font-medium mb-8"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        Ils parlent de nous
      </motion.p>
      <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
        {pressLogos.map((logo, i) => (
          <motion.div
            key={logo.name}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            whileHover={{ scale: 1.08, y: -2 }}
            className="flex items-center gap-2.5 px-5 py-3 rounded-xl bg-card/40 border border-border/30 hover:border-primary/30 transition-all cursor-default group"
          >
            <span className="text-xl group-hover:scale-110 transition-transform">{logo.icon}</span>
            <span className="text-sm font-semibold text-muted-foreground group-hover:text-foreground transition-colors">
              {logo.name}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SellPressSection;
